var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { TextCutter } from '../../../../Common/components/TextCutter';
import { COLUMN_WIDTH } from '../../../constants/table';
var ScHeaderCell = styled.div.withConfig({ displayName: "ScHeaderCell", componentId: "sc-4y4f1h" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 40px;\n  left: 50%;\n  transform-origin: center center;\n  transform: translateX(-50%) rotate(-90deg);\n  display: flex;\n  align-items: center;\n  width: 90px;\n  height: ", "px;\n  text-align: left;\n"], ["\n  position: absolute;\n  bottom: 40px;\n  left: 50%;\n  transform-origin: center center;\n  transform: translateX(-50%) rotate(-90deg);\n  display: flex;\n  align-items: center;\n  width: 90px;\n  height: ", "px;\n  text-align: left;\n"])), COLUMN_WIDTH);
var SkillHeaderCell = function (_a) {
    var skillName = _a.skillName;
    return (_jsx(ScHeaderCell, { children: _jsx(TextCutter, __assign({ title: skillName, maxNumLines: 3 }, { children: skillName }), void 0) }, void 0));
};
export { SkillHeaderCell };
var templateObject_1;
